import { createSlice } from '@reduxjs/toolkit'

export const alertsGlobal = createSlice({
  name: 'alerts',
  initialState: { isStored: null },
  reducers: {
    setIsStored: (state, action) => {
      state.isStored = action.payload
    },
  },
})

export const { setIsStored } = alertsGlobal.actions
export default alertsGlobal.reducer
